import React from 'react'
import { useRegionOffers } from '../../../../RegionOffers'
import { useRegionCountryCode } from '../../../../RegionGeo'
import styles from './styles.module.css'
import Text from '../../../../Text'
import { formatPrice } from '../../../../../utils/formats'
import '@fontsource/roboto-mono'
import PaymentMethodMessage from '../../../../Utils/PaymentMethodMessage'
import { getRegionForCurrency } from '../../../../../utils/payments'
import SecurePaymentBadge from '../SecurePaymentBadge'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import { isNullOrEmpty } from '../../../../../utils/arrays'
import { toSrc } from '../../../../../utils/imageSrc'
import { findInvoiceLineItem } from '../../../../../utils/invoiceItems'
import { $red60 } from '../../../../../styles/colors/primitives'

function InvoicePreview ({ invoice }) {
  // offers migrated off Overmind (Phase D1) → the RegionOffers seam (used by
  // renderInvoiceItem's line-item image lookup); newRegion → the RegionGeo seam
  // (Phase C2 part 2). Both threaded into the pure renderInvoice below.
  const { offers } = useRegionOffers()
  const newRegion = useRegionCountryCode()

  if (!!invoice) {
    return renderInvoice(invoice, null, offers, newRegion)
  }
}

// `shopItems` (Phase D1: the offers array from the RegionOffers seam) is threaded in
// by the caller for renderInvoiceItem's line-item image lookup; `newRegion` (Phase
// C2 part 2) likewise from the RegionGeo seam.
export const renderInvoice = (invoice, discountCodeComponent, shopItems, newRegion = null) => {
  const total = invoice.total
  const tax = (invoice && invoice.items && invoice.items.length > 0 && !!invoice.items[0].tax) ? ` (incl. ${invoice.items[0].tax.percentage}% ${invoice.items[0].tax.type})` : ''

  return (
    <>
      <div className={styles.invoiceWrapper}>
        <Text type="heading-8">SUMMARY</Text>
        { invoice && invoice.items && invoice.items.map(i => renderInvoiceItem(i.description, i.amount, i.quantity, null, shopItems, i.itemType)) }
        { discountCodeComponent }
        { renderInvoiceItem('Total' + tax, total, 1, null, shopItems) }
        { invoice.discountWarning && !discountCodeComponent && <div className={styles.discountWarning}>
          <Text type="small" color={$red60}>{invoice.discountWarning}</Text>
        </div>
        }
        { invoice.shippingInfo && <div className={styles.shippingInfo}>
          <Text type="tiny">{invoice.shippingInfo}</Text>
        </div>
        }
      </div>
      <SecurePaymentBadge/>
      <PaymentMethodMessage
        isLive={true}
        region={getRegionForCurrency(total.currency)}
        countryCode={newRegion}
        price={total}
      />
    </>
  )
}

export const renderInvoiceItem = (description, amount, quantity, textOverridePrice, shopItems, itemType) => {
  const matchingItem = findInvoiceLineItem(itemType, description, shopItems)
  const isTotal = description.toLowerCase().includes('total')
  const isDiscount = description.toLowerCase().includes('discount')
  const descriptionParts = !isTotal && !isDiscount ? description.split('(') : [description]

  // Compose the prop-driven modifier classes exactly as the former styled block did:
  // discount -> green text; and (only when NOT a shop-item row) a top border whose
  // strength depends on isTotal. A shop-item row gets no top border.
  const invoiceItemClasses = [styles.invoiceItem]
  if (isDiscount) invoiceItemClasses.push(styles.invoiceItemDiscount)
  if (!matchingItem) invoiceItemClasses.push(isTotal ? styles.invoiceItemTotalBorder : styles.invoiceItemBorder)

  return Array.from(Array(quantity || 1)).map(x => (
      <div
        className={invoiceItemClasses.join(' ')}
        key={description}
      >
        <div className={styles.imageAndTitle}>
          { matchingItem && <img className={styles.itemImage} width={48} height={48} src={!isNullOrEmpty(matchingItem.galleryImages) ? matchingItem.galleryImages[0].src : toSrc(matchingItem.imageUrl)}/> }
          { !matchingItem && description && description.toLowerCase().includes('unlock') && <div className={styles.unlockIconWrapper}><LockOpenIcon/></div>}
          <div className={styles.itemTitle}>
            { matchingItem && <Text type="tiny">DirectForce®</Text> }
            <Text type="small">{descriptionParts[0]}</Text>
            {descriptionParts[1] && <Text type="small" color="#ff0000">{'(' + descriptionParts[1]}</Text>}
          </div>
        </div>
        <div className={styles.itemPrice}>
          <Text type="small">{textOverridePrice || formatPrice(amount)}</Text>
        </div>
      </div>
    )
  )
}

export default InvoicePreview
